'use client';

/**
 * staff の API クライアント。実体は共有モジュール（@new-cti/frontend-shared）。
 * createApi(authClient, appConfig) の戻り値を名前付き再エクスポートするため、呼び出し側の
 * `import { get, post, ... } from '@/lib/api'` は従来どおり動く。
 */
import { createApi, type RecordLoginResult } from '@new-cti/frontend-shared/auth/api-core';
import { authClient } from './auth';
import { appConfig } from './app-config';

const apiClient = createApi(authClient, appConfig);

export const { get, post, put, del, recordLogin } = apiClient;

export type { RecordLoginResult };
